// import styles
import '@scss/main.scss';
import '@lib/scss/base.lib.scss';
// require main js file
require('@js/index');

require('@js/ajax/works');
require('@js/ajax/blog');

require('@js/components/header');
require('@js/components/parallax');
require('@js/components/smooth-scroll');
require('@js/components/magnet-btn');
require('@js/components/accordion');
require('@js/components/tabs');
require('@js/components/counter');
require('@js/components/sliders');
require('@js/components/sticky-sidebar');
require('@js/components/micromodal');
require('@js/components/form');
require('@js/components/toc');
require('@js/components/search-input');
require('@js/components/user-contact-form');
